import { createContext } from '../../utils/createContext.js';
export const [CollapsibleProvider, useCollapsibleContext] = createContext('CollapsibleContext');
